import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { FileInfo, FileState } from '@progress/kendo-angular-upload';

@Pipe({
  name: 'fileStatusClass',
})
export class FileStatusClassPipe implements PipeTransform {
  transform(file: FileInfo): { [klass: string]: boolean } {
    return this.getFileStatusClass(file);
  }

  private getFileStatusClass(file: FileInfo) {
    return {
      'file-validation-message': this.hasValidationErrors(file),
      'file-size': this.hasValidationErrors(file) === false,
      'text-error': this.hasValidationErrors(file) || this.isUploadFailed(file),
    };
  }

  private hasValidationErrors(file: FileInfo) {
    return _.isNil(file.validationErrors) === false;
  }

  private isUploadFailed(file: FileInfo): boolean {
    return file.state === FileState.Failed;
  }
}
